export default __webpack_public_path__ + "static/media/3015.54211fc6.png";